export function throttle(func: () => void, delay: number, trailing = true) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return () => {
    if (!timeout) {
      func();
      timeout = setTimeout(() => {
        timeout = null;

        if (trailing) {
          func();
        }
      }, delay);
    }
  };
}
